module.exports = __webpack_public_path__ + "static/img/header_bg.44d582b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/header/header_bg.png
// module id = aYqK
// module chunks = 4